<script setup lang="ts">
import { type ComponentInstance, computed } from 'vue'
import { useAssetSettings, useReconFileAttachment, useReconFileRemoval } from '@/composables/assets/assets';
import Card from "@/components/Card/card-container.vue";
import CardContent from "@/components/Card/card-content.vue";
import CardHeader from "@/components/Card/card-header.vue";
import CardHeaderItem from '@/components/Card/card-header-item.vue';
import InputLabel from "@/components/input-label.vue";
import FileUploadList from '@/shared/components/FileUploadList.vue'
import FileUploadButton from '@/shared/components/FileUploadButton.vue'
import { createReusableTemplate } from '@vueuse/core'
import ContentLoader from "@/components/content-loader.vue";
import { AssetSetupFileType } from '@/features/assets/constants';
import { TargetSystem } from '@/shared/constants';
import GridContainer from "@/components/grid-container.vue";
import GridItem from "@/components/grid-item.vue";
const props = defineProps<{ assetCode: string }>();

const { data: assetData, isLoading: assetLoading} = useAssetSettings(props.assetCode);
const { mutateAsync: removeFile } = useReconFileRemoval(props.assetCode)
const { mutateAsync: attachFile } = useReconFileAttachment(props.assetCode)
function completeUpload(uploadId: string, closeModal: () => void) {
  closeModal()
  attachFile(uploadId)
}

const uploadId = computed(() => assetData.value?.contractTerms.utilityReconciliationUploadedFileId)
</script>
<template>
    <Card>
        <CardHeader>
            <CardHeaderItem>RECONCILIATION</CardHeaderItem>
        </CardHeader>
        <CardContent>
          <ContentLoader loading v-if="assetLoading" />
          <template v-else>
            <div class="d-flex align-items-center justify-content-between">
              <InputLabel>Eskom Reconciliation</InputLabel>
              <FileUploadButton
                class="w-30"
                :target-system="TargetSystem.AssetManagement"
                :max="1"
                :required="false"
                @complete="({ uploaded, close }) => uploaded.length > 0 ? completeUpload(uploaded[0], close) : void(0)"
              />
            </div>
            <FileUploadList
              :uploads="uploadId ? [{ id: uploadId, abilities: ['download', 'delete'] }] : []"
              :on-delete="() => removeFile()"
              :class="{ 'mt-2': uploadId }"
              tooltip-placement="bottom" />
          </template>
        </CardContent>
    </Card>
</template>
<style module lang="scss">
.label-upload-row {
  display: flex;
  align-items: center;
  gap: 255px;
}
</style>
